import React from 'react';
import LoadingSpinner from '../loadingSpinner/loadingSpinner';
const Fallback = () => (
  <div className="w-100 flex h-[100vh] items-center justify-center">
    <LoadingSpinner color="primary" />
  </div>
);

export default Fallback;
